export const contacto = [
  {
    label: "Id",
    name: "idcontacto",
    type: "INTEGER",
    readonly: true,
  },
  {
    label: "Empresa",
    name: "idempresa",
    type: "empresa",
    showOnList: true,
  },
  {
    label: "Nombre",
    name: "nombre",
    type: "STRING",
    showOnList: true,
  },
  {
    label: "Apellido",
    name: "apellido",
    type: "STRING",
    showOnList: true,
  },
  {
    label: "Teléfono",
    name: "telefono",
    type: "STRING",
    allowNull: true,
    showOnList: true,
  },
  {
    label: "Email",
    name: "mail",
    type: "STRING",
    allowNull: true,
    showOnList: true,
  },
  {
    label: "Comentarios",
    name: "comentarios",
    type: "LONGSTRING",
    allowNull: true,
    showOnList: true,
  },
];
